import { Component, Input } from '@angular/core';
import { Price } from '@markant-platform/cartridge/model';

@Component({
  selector: 'markant-platform-price-setup-costs',
  templateUrl: './price-setup-costs.component.html',
  styleUrls: ['./price-setup-costs.component.scss'],
})
export class PriceSetupCostsComponent {
  @Input() setUpCosts!: Price;
  @Input() isUpgradeCandidate = false;
}
